<template>
  <autocomplete-search
    v-model="internalValue"
    :search-function="performSearch"
    :label="label"
    placeholder="Enter at least 5 characters to search..."
    :display-field="'Subject'"
    :value-field="'OID'"
    :subtitle-field="'BranchName'"
    :outlined="true"
    :dense="true"
    :hide-details="hideDetails"
    :dark="dark"
    @change="handleChange"
  />
</template>

<script>
import { mapActions } from 'vuex'
import AutocompleteSearch from '@/components/Tenancies/AutocompleteSearch.vue'

export default {
  name: 'GenericSearch',
  components: {
    AutocompleteSearch
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    schemaType: {
      type: String,
      required: true,
      validator: value => [
        'PropertyOwnable',
        'LettingsTenant',
        'LettingsLandlord',
        'MaintenanceContractor',
        'ApplicationPerson',
        'LettingsTenancy'
      ].includes(value)
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        // If we have a value but no object, we need to handle this case
        if (newVal && !this.internalValue) {
          this.internalValue = { OID: newVal }
        } else if (!newVal) {
          this.internalValue = null
        }
      }
    }
  },
  methods: {
    ...mapActions('TenanciesManagement', ['searchEntity']),
    
    async performSearch(searchTerm) {
      return await this.searchEntity({
        schemaType: this.schemaType,
        searchTerm
      })
    },
    
    handleChange(value) {
      // Extract just the OID for the v-model
      const id = value ? value.OID : ''
      this.$emit('input', id)
      this.$emit('change', id)
      
      // Update internal value
      this.internalValue = value
    }
  }
}
</script>